var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-greyx rounded py-16 text-blackdok text-center px-5 text-base font-bold"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }